// import first_image from './sea-bg.jpg';
import styles from './Row.module.css';
import React from "react";
const Row = ({row,links}) => {

  return (
    <div className={styles.rowCover}>

        {
            row.heading ? (<><h3>{row.heading}</h3></>) :null
        }
        
      
        {
            row.image_url ? (
                <>
                    <br/>
                    <div className={styles.img}>
                    
                        <img  src={row.image_url} alt="associated_img" />
                    </div>
                    <br /><br />
                </>
            ) : null
        }
 
        <ul className={styles.list}>

            {
                row.listItem ? (<> {row.listItem.map((item)=>(
                    <li>{item}</li>
                ))}
                </>) : null
            }

        </ul>

        {links ? <ul className={styles.listLinks}>

            {
                row.linkList.map((item)=>(
                    <li><a href={item.link} target="_blank" rel="noreferrer">{item.linkTitle}</a></li>
                ))
            }

        </ul> : null}
    </div>
  );
};

export default Row;
